export enum DialogResult {
    Cancelled,
    Success,
    Error
}